<script>
  let showNavigation = false;

  function toggleMenu() {
    showNavigation = !showNavigation;
  }

  function handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleMenu();
    }
  }
</script>

<header class="header" class:expanded={showNavigation}>
  <div class="top-bar">
    <div class="logo">
      <a href="../#/">
        <img src="../images/logos/white.svg" alt="Freedom Writers Foundation logo (in all white)" />
      </a>
    </div>
    <div class="hamburger-menu"
         class:expanded={showNavigation}
         on:click={toggleMenu}
         on:keydown={handleKeydown}
         tabindex="0"
         role="button"
         aria-label="Toggle navigation menu">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
  <nav class="navigation" class:show={showNavigation}>
    <a href="../about" class="nav-link">About</a>
    <a href="../outreach/" class="nav-link">Programs</a>
    <a href="../connect/" class="nav-link">Connect</a>
    <a href="../donate/" class="donate-button">Donate</a>
  </nav>
</header>

<style>
  .header {
    background-color: #f7931e;
    padding: 0 20px;
    transition: height 0.3s ease;
  }

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo img {
    height: 107px;
    padding: 0.7rem;
  }

  .navigation {
    display: none;
    font-family: 'Oswald', sans-serif;
    font-size: 1.34rem;
  }

  .navigation.show {
    display: block;
    text-align: center;
  }

  .nav-link, .donate-button {
    display: block;
    text-decoration: none;
    color: white;
    padding: 10px;
    text-align: center;
    font-weight: normal;
  }

  .hamburger-menu {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center the bars vertically */
  height: 30px; /* Adjust the height to fit the bars and spacing */
  width: 35px; /* Width to contain the bars */
  padding: 0px 0; /* Add padding to the top and bottom if needed */
}

.bar {
  width: 100%; /* Full width of the container */
  height: 4px; /* Height of the bar */
  background-color: #fff;
  margin: 4px 0; /* Adjust the space between bars */
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* Adjustments for expanded menu icon */
.hamburger-menu.expanded .bar:nth-child(1) {
  transform: translateY(8px) rotate(45deg); /* Adjust Y translation to match new spacing */
}

.hamburger-menu.expanded .bar:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.expanded .bar:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg); /* Adjust Y translation to match new spacing */
}


  @media (max-width: 768px) {
    .header.expanded {
      height: 100vh;
    }

    .logo img {
      height: 77px;
      padding: 0.7rem;
    }

    .hamburger-menu {
      display: block;
    }

    .navigation.show {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    .nav-link:hover, .donate-button:hover {
      color: #000;
    }
  }

  @media (min-width: 769px) {
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .navigation {
      display: flex;
      align-items: center;
      gap: 15px;
    }

    .nav-link:hover {
      color: black;
    }

    .nav-link, .donate-button {
      display: inline-block;
    }

    .hamburger-menu {
      display: none;
    }

    .donate-button {
      margin-left: 1.25rem;
      color: black;
      background-color: white;
      padding: 10px 20px;
      border-radius: 5px;
      font-weight: normal;
      font-size: 1rem;
      transition: 0.25s ease;
      display: inline-block;
      cursor: pointer;
      font-size: 1.34rem;
    }

    .donate-button:hover {
      scale: 1.17;
    }
  }
</style>